/* @flow */
import React from 'react';
import AuthActions from 'auth/AuthActions';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';

type Props = {
  location: Object,
};

export default class TreasurerLandingPage extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  componentWillMount() {
    AuthActions.checkLoggedIn().then(() => {
      this.context.router.push({
        pathname: '/activities/treasurer/add_bank_account',
        query: this.props.location.query,
      });
    }, () => {
      this.context.router.push({
        pathname: '/activities/treasurer/sign_up',
        query: this.props.location.query,
      });
    });
  }

  render() {
    return <CenteredLoadingIndicator />;
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/TreasurerLandingPage.jsx